"use client";

import { useEffect } from "react";
import { ApolloForm } from "./ApolloForm";
import { CUSTOM_FORM_CONFIGS, type CustomFormId } from "./custom-form-config";

interface CustomFormProps {
	formId: CustomFormId;
}

export function CustomForm({ formId }: CustomFormProps) {
	const config = CUSTOM_FORM_CONFIGS[formId];

	return (
		<ApolloForm
			title={config.title}
			description={config.description}
			fields={config.fields}
			required_fields={config.required_fields}
			field_labels={config.field_labels}
			scheduling_link={config.scheduling_link}
			form_id={config.form_id}
			hidden_form_id_value={config.form_id}
			success_message={config.success_message}
		/>
	);
}

export type { CustomFormId };
